import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  picture: {
    width: theme.spacing(17),
    height: theme.spacing(17),
  },
}));
